import { render, staticRenderFns } from "./PageTowns.vue?vue&type=template&id=9c82b598&scoped=true&"
import script from "./PageTowns.vue?vue&type=script&lang=ts&"
export * from "./PageTowns.vue?vue&type=script&lang=ts&"
import style0 from "./PageTowns.vue?vue&type=style&index=0&id=9c82b598&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c82b598",
  null
  
)

export default component.exports